import { createI18n } from "vue-i18n";
import zh_CN from "@/language/zh-cn";
import en_US from "@/language/en";
import ja_JP from "@/language/ja";
import ko_KR from "@/language/ko";

const messages = {
  "en-US": en_US,
  "zh-CN": zh_CN,
  "ja-JP": ja_JP,
  "ko-KR": ko_KR,
};
const navigatorLanguage = navigator.language === "zh-CN" ? "zh-CN" : "en-US";
export const i18n = createI18n({
  legacy: false,
  messages,
  locale:
    (process.env.VUE_APP_LANGURAGE &&
      localStorage.getItem(process.env.VUE_APP_LANGURAGE)) ||
    navigatorLanguage ||
    "zh-CN",
  fallbackLocale: "zh-CN",
});
console.log(process.env.VUE_APP_LANGURAGE, process.env.VUE_APP_TOKEN_KEY);
if (
  process.env.VUE_APP_LANGURAGE &&
  !localStorage.getItem(process.env.VUE_APP_LANGURAGE)
) {
  localStorage.setItem(
    process.env.VUE_APP_LANGURAGE,
    navigatorLanguage || "zh-CN"
  );
}
